import React from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from '@material-ui/core'
import {
  PeopleIcon,
  GrantAccessIcon,
  ModifyAccessIcon,
  AddNewMessageIcon,
  AmendDeleteMessageIcon,
  StoreStockIcon,
  StoreSalesIcon,
  SalesIcon,
  PurchaseOrderIcon,
  OnlineSalesIconIcon,
  DepotDeliveryIcon,
  PromotionForecastIcon,
  WholesaleSalesIcon,
  InboundServiceLevelIcon,
  SalesForecastIcon,
  OrderForecastIcon,
  CreateCompanyProfile,
  ManageCompanyProfile,
  DepotStockIcon,
  ProductReferenceIcon,
  WastageAndMarkdownIcon,
  MorrisonsDocumentsIcon,
  RangedProductsIcon,
} from 'assets'
import { AuthContainer } from 'containers'
import { Alert } from 'components'
import { PageLink } from 'types/pages'
import { getPageCondition } from 'utils/utilities'

const icons = [
  {
    name: 'people',
    icon: <PeopleIcon />,
  },
  {
    name: 'grant-access',
    icon: <GrantAccessIcon />,
  },
  {
    name: 'modify-access',
    icon: <ModifyAccessIcon />,
  },
  {
    name: 'add-new-message',
    icon: <AddNewMessageIcon />,
  },
  {
    name: 'amend-delete-message',
    icon: <AmendDeleteMessageIcon />,
  },
  {
    name: 'morrisons-documents',
    icon: <MorrisonsDocumentsIcon />,
  },
  {
    name: 'create-company-profile',
    icon: <CreateCompanyProfile />,
  },
  {
    name: 'manage-company-profile',
    icon: <ManageCompanyProfile />,
  },
  {
    name: 'store-stock',
    icon: <StoreStockIcon />,
  },
  {
    name: 'store-sales',
    icon: <StoreSalesIcon />,
  },
  {
    name: 'sales',
    icon: <SalesIcon />,
  },
  {
    name: 'purchase-order',
    icon: <PurchaseOrderIcon />,
  },
  {
    name: 'online-sales',
    icon: <OnlineSalesIconIcon />,
  },
  {
    name: 'depot-delivery',
    icon: <DepotDeliveryIcon />,
  },
  {
    name: 'promotion-forecast',
    icon: <PromotionForecastIcon />,
  },
  {
    name: 'wholesale-sales',
    icon: <WholesaleSalesIcon />,
  },
  {
    name: 'product-reference',
    icon: <ProductReferenceIcon />,
  },
  {
    name: 'inbound-service-level',
    icon: <InboundServiceLevelIcon />,
  },
  {
    name: 'sales-forecast',
    icon: <SalesForecastIcon />,
  },
  {
    name: 'order-forecast',
    icon: <OrderForecastIcon />,
  },
  {
    name: 'depot-stock',
    icon: <DepotStockIcon />,
  },
  {
    name: 'wastage-and-markdown',
    icon: <WastageAndMarkdownIcon />,
  },
  { name: 'ranged-products', icon: <RangedProductsIcon /> },
] as const

export const iconLiteralNames = icons.map(({ name }) => {
  return name
})

export const AppTile = (props: PageLink) => {
  const { icon = 'people', text, routeTo, condition } = props

  const history = useHistory()
  const { userType, selectedSupplier } = AuthContainer.useContainer()
  const [open, setOpen] = React.useState(false)

  const pageCondition = getPageCondition({ condition, userType, selectedSupplier })

  const selectedIcon = icons.find((item) => {
    return item.name === icon
  })?.icon

  return (
    <div className="w-full h-20 sm:w-80" data-testid="app-loader">
      <Button
        variant="contained"
        className="w-full h-full px-6 justify-start bg-white border border-black-10 rounded-lg text-left text-lg normal-case font-medium"
        onClick={() => {
          pageCondition.enabled ? history.push(routeTo) : setOpen(true)
        }}
      >
        <div className="pr-4">{selectedIcon}</div>
        <div className="text-primary-darker">{text}</div>
      </Button>
      {open && (
        <Alert
          title={text}
          message={pageCondition.message ?? 'This page is disabled!'}
          open={open}
          onClose={() => setOpen(false)}
        />
      )}
    </div>
  )
}
